import{a as e}from"./chunk-5TM2W72O.js";import{m as r}from"./chunk-HBP5N4FR.js";r();function d(o){return e()===o}export{d as a};
//# sourceMappingURL=chunk-KG4M4ACY.js.map
